// extracted by mini-css-extract-plugin
export var borderBottom = "Heading-module--borderBottom--96eb9";
export var cyan = "Heading-module--cyan--8b599";
export var fill = "Heading-module--fill--ef0b6";
export var h1 = "Heading-module--h1--7f76a";
export var h2 = "Heading-module--h2--06249";
export var h3 = "Heading-module--h3--8391f";
export var h4 = "Heading-module--h4--795d1";
export var h5 = "Heading-module--h5--25d3a";
export var h6 = "Heading-module--h6--ea9c5";
export var orange = "Heading-module--orange--3dfb5";
export var pink = "Heading-module--pink--506ab";
export var purple = "Heading-module--purple--89250";
export var red = "Heading-module--red--d808a";
export var root = "Heading-module--root--e9fa1";